const ROOT_SELECTOR = '.header-main__language';
const ICON_SELECTOR = '.header-main__language-icon';
const OPEN_CLASS = 'is-open';
const READY_KEY = 'languageReady';

function setOpen( root, icon, open ) {
	root.classList.toggle( OPEN_CLASS, open );
	icon.setAttribute( 'aria-expanded', String( open ) );
}

function initSwitcher( root ) {
	if ( root.dataset[ READY_KEY ] ) {
		return;
	}
	root.dataset[ READY_KEY ] = 'true';

	const icon = root.querySelector( ICON_SELECTOR );
	if ( ! icon ) {
		return;
	}

	icon.setAttribute( 'role', 'button' );
	icon.setAttribute( 'tabindex', '0' );
	icon.setAttribute( 'aria-label', 'Change language' );
	icon.setAttribute( 'aria-haspopup', 'true' );
	setOpen( root, icon, false );

	const toggle = () => setOpen( root, icon, ! root.classList.contains( OPEN_CLASS ) );

	icon.addEventListener( 'click', toggle );
	icon.addEventListener( 'keydown', ( event ) => {
		if ( event.key === 'Enter' || event.key === ' ' ) {
			event.preventDefault();
			toggle();
		}
	} );

	document.addEventListener( 'click', ( event ) => {
		if ( ! root.contains( event.target ) ) {
			setOpen( root, icon, false );
		}
	} );

	root.addEventListener( 'keydown', ( event ) => {
		if ( event.key === 'Escape' && root.classList.contains( OPEN_CLASS ) ) {
			setOpen( root, icon, false );
			icon.focus();
		}
	} );
}

const HeaderLanguage = {
	init( root = document ) {
		root.querySelectorAll( ROOT_SELECTOR ).forEach( initSwitcher );
	},
};

export default HeaderLanguage;
